<template>
  <div>
    <!-- No mobile, na listagem inline (isOpen), a busca e o "Abrir Comanda"
         ficam no FAB — escondidos aqui. No modal de busca (isOpen=false)
         continuam visíveis. -->
    <div class="d-flex" v-if="!($store.state.isMobile && isOpen)">
      <b-input
        placeholder="localizar"
        v-model="filtro"
        autocomplete="off"
        ref="txtBuscaComanda"
        autofocus
        @keydown.enter="clickSel"
      />
      <b-btn
        variant="success"
        class="w-25 ml-4"
        @click="$emit('openComanda')"
        v-if="showOpenComanda"
        >Abrir Comanda</b-btn
      >
    </div>
    <hr v-if="!($store.state.isMobile && isOpen)" />
    <div :class="{ row: isOpen }">
      <div
        class="col-12 d-flex justify-content-between"
        v-if="!($store.state.isMobile && isOpen)"
      >
        <div class="d-flex">
          <b-btn
            v-if="comandaViewType == 'table'"
            variant="info"
            @click="print"
            class="mr-1"
            ><b-icon-printer /> Imprimir</b-btn
          >
          <export-excel :data="relatorioExcel">
            <b-btn variant="secondary"> <b-icon-file-excel /> Exportar </b-btn>
          </export-excel>
          <b-btn
            v-if="!modoSelecao"
            variant="outline-primary"
            class="ml-1"
            @click="entrarSelecao"
            title="Selecionar comandas para unificar"
          >
            <i class="fa fa-object-group mr-1"></i> Unificar
          </b-btn>
        </div>
        <div>
          <b-btn-group>
            <b-button-group
              size="sm"
              v-model="comandaViewType"
            >
              <b-button
                :variant="comandaViewType == 'card' ? 'primary' : 'none'"
                value="card"
                :active="comandaViewType == 'card'"
                @click="comandaViewType = `card`"
                ><b-icon-window-dock /> Card</b-button
              >
              <b-button
                :variant="comandaViewType == 'table' ? 'primary' : 'none'"
                value="table"
                :active="comandaViewType == 'table'"
                @click="comandaViewType = `table`"
                ><b-icon-list /> Lista
              </b-button>
            </b-button-group>
          </b-btn-group>
        </div>
      </div>
      <div
        v-if="modoSelecao"
        class="col-12 mb-2 p-2 d-flex justify-content-between align-items-center bg-light rounded"
      >
        <span>
          <strong>{{ comandasSelecionadas.length }}</strong> comanda(s)
          selecionada(s)
          <small class="text-muted ml-1">— marque 2 ou mais para unificar</small>
        </span>
        <div>
          <b-btn variant="link" size="sm" @click="sairSelecao">Cancelar</b-btn>
          <b-btn
            variant="success"
            size="sm"
            :disabled="comandasSelecionadas.length < 2"
            @click="abrirUnificar"
          >
            <i class="fa fa-object-group mr-1"></i> Unificar selecionadas
          </b-btn>
        </div>
      </div>
      <template v-if="comandaViewType == 'card'">
        <!-- ===== Mobile: lista compacta estilo app nativo ===== -->
        <div class="col-12 comandas-mobile" v-if="$store.state.isMobile">
          <div
            v-for="cm in comandas"
            :key="`comandaM_${cm.comanda.id}_${cm.comanda.nome}`"
            class="comanda-m"
            :class="{
              'comanda-m--closed': cm.comanda.dt_fechada,
              'comanda-m--sel': modoSelecao && isSelecionada(cm),
            }"
            @click="select(cm)"
          >
            <div class="comanda-m__check" v-if="modoSelecao">
              <b-icon
                :icon="isSelecionada(cm) ? 'check-square-fill' : 'square'"
              />
            </div>
            <div class="comanda-m__body">
              <div class="comanda-m__top">
                <span class="comanda-m__title">
                  <i class="fa fa-barcode mr-1"></i>{{ getNome(cm.comanda, 0) }}
                </span>
                <span class="comanda-m__total">{{
                  (cm.comanda.vl_total || 0) | currencyMask
                }}</span>
              </div>
              <div
                class="comanda-m__client"
                v-if="
                  getNome(cm.comanda, 1) && getNome(cm.comanda, 1).trim() != ``
                "
              >
                <i class="fa fa-user mr-1"></i>{{ getNome(cm.comanda, 1)
                }}<span
                  v-if="
                    getNome(cm.comanda, 2) && getNome(cm.comanda, 2).trim() != ``
                  "
                >
                  · {{ getNome(cm.comanda, 2) }}</span
                >
              </div>
              <div class="comanda-m__meta">
                <span>
                  <i class="fa fa-clock mr-1"></i
                  >{{ cm.mesa.dt_aberta | moment("DD/MM HH:mm") }}
                </span>
                <span class="comanda-m__badge" v-if="cm.comanda.dt_fechada">
                  <i class="fa fa-lock mr-1"></i>Fechada
                </span>
              </div>
            </div>
            <i
              class="fa fa-chevron-right comanda-m__chev"
              v-if="!modoSelecao && !cm.comanda.dt_fechada"
            ></i>
          </div>
        </div>

        <!-- ===== Desktop: layout atual ===== -->
        <template v-else>
          <div
            v-for="cm in comandas"
            :key="`comanda_${cm.comanda.nome}_${Math.random()}`"
            :class="{ 'col-12 col-md-4 col-lg-3 p-2 ': isOpen }"
            @click="select(cm)"
          >
            <div
              class="comanda"
              :class="{
                cmdOpen: isOpen,
                'bg-danger text-white': cm.comanda.dt_fechada,
                'border-primary border-2 shadow-sm':
                  modoSelecao && isSelecionada(cm),
              }"
            >
              <div v-if="modoSelecao" class="text-primary mb-1">
                <b-icon
                  :icon="isSelecionada(cm) ? 'check-square-fill' : 'square'"
                />
                <span class="ml-1 small">{{
                  isSelecionada(cm) ? "Selecionada" : "Selecionar"
                }}</span>
              </div>
              <div class="row text-left">
                <div :class="{ 'col-12 col-md-4': !isOpen, 'col-12': isOpen }">
                  <strong
                    ><i class="fa fa-barcode mr-1"></i
                    >{{ getNome(cm.comanda, 0) }}</strong
                  >
                </div>
                <div
                  v-if="
                    getNome(cm.comanda, 1) && getNome(cm.comanda, 1).trim() != ``
                  "
                  :class="{ 'col-12 col-md-4': !isOpen, 'col-12': isOpen }"
                >
                  <i class="fa fa-user mr-1"></i>{{ getNome(cm.comanda, 1) }}
                </div>
                <div
                  :class="{ 'col-12 col-md-4': !isOpen, 'col-12': isOpen }"
                  v-if="
                    getNome(cm.comanda, 2) && getNome(cm.comanda, 2).trim() != ``
                  "
                >
                  <i class="fa fa-phone mr-1"></i>{{ getNome(cm.comanda, 2) }}
                </div>
                <div :class="{ 'col-12 col-md-4': !isOpen, 'col-12': isOpen }">
                  <i class="fa fa-calendar mr-1"></i
                  >{{ cm.mesa.dt_aberta | moment("DD/MM/YYYY HH:mm") }}
                </div>
              </div>
              <div v-if="cm.comanda.dt_fechada">
                <i class="fa fa-lock mr-1"></i>Comanda Fechada
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="comandaViewType == 'table'">
        <div
          class="col-12"
          id="dvPrint"
        >
          <h5>Comandas em aberto</h5>
          <hr />
          <b-table
            :items="comandasTable"
            :fields="[
              { key: 'comanda', label: 'Comanda', sortable: true },
              {
                key: 'cliente',
                label: 'Comanda',
                sortable: true,
                class: 'text-left',
              },
              { key: 'dt_aberta', label: 'Aberta', sortable: true },
              { key: 'vl_total', label: 'Total', sortable: true },
              {
                key: 'vl_pago',
                label: 'Pago',
                sortable: true,
                class: 'text-info',
              },
              {
                key: 'vl_aberto',
                label: 'Restante',
                sortable: true,
                class: 'text-right text-danger',
              },
            ]"
            style="font-size: 10px"
            small
            hover
            selectable
            select-mode="single"
            ref="table"
            @row-selected="
              (row) => (row && row.length > 0 ? select(row[0].obj) : () => {})
            "
          >
            <template #cell(dt_aberta)="row">
              {{ row.item.dt_aberta | moment("DD/MM/YYYY HH:mm") }}
            </template>
            <template #cell(vl_total)="row">
              {{ row.item.vl_total | currency }}
            </template>
            <template #cell(vl_pago)="row">
              <span v-if="row.item.vl_pago">
                {{
                  (row.item.vl_pago ? row.item.vl_pago : "") | currency
                }} </span
              ><span v-else>--</span>
            </template>
            <template #cell(vl_aberto)="row">
              {{
                ((row.item.vl_total || 0) - (row.item.vl_pago || 0)) | currency
              }}
            </template>
          </b-table>
          <hr />
          <div
            class="d-flex justify-content-between p-2"
            style="border: 1px solid #ccc"
          >
            <div>Total</div>
            <div>
              {{
                comandasTable.reduce((acc, x) => acc + x.vl_total, 0) | currency
              }}
            </div>
          </div>
          <div
            class="d-flex justify-content-between p-2 text-info mt-1"
            style="border: 1px solid #ccc"
          >
            <div>Pago</div>
            <div>
              {{
                comandasTable.reduce((acc, x) => acc + x.vl_pago, 0) | currency
              }}
            </div>
          </div>
          <div
            class="d-flex justify-content-between p-2 text-danger mt-1"
            style="border: 1px solid #ccc"
          >
            <div>Á Receber</div>
            <div>
              {{
                comandasTable.reduce(
                  (acc, x) => acc + x.vl_total - x.vl_pago,
                  0
                ) | currency
              }}
            </div>
          </div>
        </div>
      </template>
    </div>

    <comanda-unificar-modal
      :modal-id="modalUnificarId"
      :itens="comandasSelecionadas"
      @unificado="onComandasUnificadas"
    />
  </div>
</template>

<script>
import PrinterWindowHelper from "../../utils/PrinterWindowHelper";
import ComandaUnificarModal from "@/components/mesas/ComandaUnificarModal.vue";
export default {
  components: { ComandaUnificarModal },
  props: {
    mesas: Array,
    isOpen: Boolean,
    showOpenComanda: Boolean,
  },
  mounted() {
    // O campo de busca pode estar escondido (mobile + listagem inline).
    if (this.$refs.txtBuscaComanda) this.$refs.txtBuscaComanda.focus();
    //loadviewconfig from storage
    // No mobile inline o seletor Card/Lista some, então força card (melhor no
    // mobile); nos demais casos respeita a preferência salva.
    if (this.$store.state.isMobile && this.isOpen) {
      this.comandaViewType = "card";
    } else {
      this.comandaViewType = localStorage.getItem("comandaViewType") || "card";
    }
  },
  data() {
    return {
      filtro: "",
      comandaViewType: "card",
      modoSelecao: false,
      // ids de mesa_comandas selecionados para unificação
      selecionados: [],
    };
  },
  watch: {
    comandaViewType: function () {
      this.writeViewConfig();
    },
  },
  computed: {
    relatorioExcel: function () {
      return this.comandasTable.map((x) => ({
        Comanda: x.comanda,
        Cliente: x.cliente,
        Aberta: x.dt_aberta,
        Total: x.vl_total,
        Pago: x.vl_pago,
        Restante: x.vl_total - x.vl_pago,
      }));
    },
    comandasTable: function () {
      return this.comandas.map((x) => ({
        comanda: this.getNome(x.comanda, 0),
        cliente: `${x.comanda.nome ? this.getNome(x.comanda, 1) : ""} - ${
          x.comanda.nome ? this.getNome(x.comanda, 2) : ""
        }`,
        dt_aberta: x.mesa.dt_aberta,
        vl_total: x.comanda.vl_total,
        vl_pago: x.comanda.vl_pago,
        vl_aberto: x.comanda.vl_aberto,
        obj: x,
      }));
    },
    comandas: function () {
      let res = [];
      for (let m of this.mesas.filter((x) => x.id)) {
        res.push(
          ...m.comandas.map((c) => ({
            mesa: m,
            comanda: c,
          }))
        );
      }
      res = res.filter(
        (x) =>
          (this.filtro &&
            this.filtro != "" &&
            x.comanda.nome
              .toLowerCase()
              .indexOf(this.filtro.toLocaleLowerCase()) >= 0) ||
          !this.filtro
      );

      // Ordena as últimas primeiro: decrescente pela data de abertura da
      // sessão (mesa_controle.dt_aberta), com o id de mesa_controle como
      // desempate/fallback.
      res = res.sort((a, b) => {
        // Usa $moment (vue-moment) em vez de new Date: "YYYY-MM-DD HH:mm:ss"
        // com espaço retorna Invalid Date no WebKit/iOS (PWA roda em iPad).
        const da =
          a.mesa && a.mesa.dt_aberta ? this.$moment(a.mesa.dt_aberta).valueOf() : 0;
        const db =
          b.mesa && b.mesa.dt_aberta ? this.$moment(b.mesa.dt_aberta).valueOf() : 0;
        if (db !== da) return db - da;
        return (b.mesa && b.mesa.id ? b.mesa.id : 0) -
          (a.mesa && a.mesa.id ? a.mesa.id : 0);
      });

      // Dedup por nome (mantém a mais recente, pois já está ordenado desc).
      // No modo seleção o dedup é desligado para que duplicatas fiquem
      // visíveis e possam ser marcadas para unificação.
      if (!this.modoSelecao) {
        res = res.reduce((ret, vl) => {
          let has = ret.find((x) => x.comanda.nome == vl.comanda.nome);
          if (!has) {
            ret.push(vl);
          }
          return ret;
        }, []);
      }
      return res;
    },
    comandasSelecionadas: function () {
      return this.comandas.filter(
        (cm) => cm.comanda && this.selecionados.indexOf(cm.comanda.id) >= 0
      );
    },
    // Id único por instância (este componente pode ser montado em mais de um
    // lugar — MesasGeral, MesasCaixa, MesaNew — evita colisão de modal.
    modalUnificarId: function () {
      return "modal-unificar-comandas-" + this._uid;
    },
  },
  methods: {
    exportar() {},
    print() {
      PrinterWindowHelper(document.querySelector("#dvPrint").innerHTML);
    },
    writeViewConfig() {
      localStorage.setItem("comandaViewType", this.comandaViewType);
    },
    getNome(comanda, index) {
      if (comanda && comanda.nome && comanda.nome.includes("|")) {
        return comanda.nome.split("|")[index];
      } else {
        return comanda.nome || "";
      }
    },
    clickSel() {
      if (this.comandas && this.comandas.length > 0) {
        this.select(this.comandas[0]);
      }
    },
    select(comanda) {
      // No modo seleção, clicar alterna a marcação ao invés de abrir.
      if (this.modoSelecao) {
        this.toggleSelecao(comanda);
        return;
      }
      console.log("comanda", comanda);
      // this.$emit("mesa", comanda.mesa);
      this.$emit("comanda", comanda.comanda);

      if(this.$refs.table && this.$refs.table.clearSelected)
        this.$refs.table.clearSelected();
    },
    entrarSelecao() {
      // Unificação só faz sentido na visão de cards.
      this.comandaViewType = "card";
      this.modoSelecao = true;
      this.selecionados = [];
    },
    sairSelecao() {
      this.modoSelecao = false;
      this.selecionados = [];
    },
    isSelecionada(cm) {
      return !!cm && !!cm.comanda && this.selecionados.indexOf(cm.comanda.id) >= 0;
    },
    toggleSelecao(cm) {
      if (!cm || !cm.comanda || !cm.comanda.id) return;
      const idx = this.selecionados.indexOf(cm.comanda.id);
      if (idx >= 0) {
        this.selecionados.splice(idx, 1);
      } else {
        this.selecionados.push(cm.comanda.id);
      }
    },
    abrirUnificar() {
      if (this.comandasSelecionadas.length < 2) return;
      this.$bvModal.show(this.modalUnificarId);
    },
    onComandasUnificadas() {
      // A lista é atualizada via socket (listMesas). Apenas limpa a seleção.
      this.sairSelecao();
    },
  },
};
</script>

<style lang="scss" scoped>
.comanda {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 5px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    border-color: #ccc;
    box-shadow: 0px 0px 10px rgba(160, 160, 160, 0.3);
    background-color: #f5f5f5;
  }
}
.cmdOpen {
  color: #555;
  min-height: 120px;
  background-color: #f8f8f8;
  &:hover {
    transform: scale(1.05);
  }
}

/* ===== Mobile: lista de comandas compacta (app nativo) ===== */
.comandas-mobile {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  // padding-left/right menor que o col-12 padrão; bottom folga p/ o menu
  // inferior + FAB não cobrirem a última comanda.
  padding: 8px 8px 120px;
}

.comanda-m {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  // nome do cliente é o único bloco não-flex; herdaria text-align: center de
  // um ancestral. Força à esquerda.
  text-align: left;
  background: #fff;
  border: 1px solid #ececf0;
  border-left: 4px solid #34c759; // acento de status: aberta
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform 0.12s ease, background-color 0.12s ease,
    box-shadow 0.12s ease;

  &:active {
    transform: scale(0.985);
    background-color: #f5f5f7;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }
  &--closed {
    border-left-color: #ff3b30;
    background: #fff6f5;
  }
  &--sel {
    border-color: #007aff;
    box-shadow: 0 0 0 2px rgba(0, 122, 255, 0.25);
  }
}

.comanda-m__check {
  flex: 0 0 auto;
  color: #007aff;
  font-size: 20px;
  line-height: 1;
}

.comanda-m__body {
  flex: 1 1 auto;
  min-width: 0; // permite truncar texto
}

.comanda-m__top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.comanda-m__title {
  font-weight: 700;
  font-size: 15px;
  color: #1c1c1e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  i {
    color: #8a8a8e;
  }
}

.comanda-m__total {
  flex: 0 0 auto;
  font-weight: 700;
  font-size: 15px;
  color: #1c1c1e;
}

.comanda-m__client {
  margin-top: 2px;
  font-size: 13px;
  color: #3a3a3c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  i {
    color: #8a8a8e;
  }
}

.comanda-m__meta {
  display: flex;
  align-items: center;
  margin-top: 6px;
  font-size: 12px;
  color: #8a8a8e;
}

.comanda-m__badge {
  margin-left: auto;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: #ffe5e3;
  color: #ff3b30;
}

.comanda-m__chev {
  flex: 0 0 auto;
  color: #c4c4c8;
  font-size: 14px;
}
</style>
